import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { ExceptionCalendarEvent } from '../../../types';
import { EventCardWrapper } from '../../column-events/event-card-wrapper';

interface Props {
  event: ExceptionCalendarEvent;
}
export const ExceptionEvent = ({ event }: Props) => {
  return (
    <EventCardWrapper eventType={'exception'} containerStyle={containerStyle}>
      {event.eventType}
    </EventCardWrapper>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  // TODO: move it to common css
  background:
    'repeating-linear-gradient(135deg, rgb(244, 245, 247) 0px, rgb(244, 245, 247) 0.6rem, rgb(218, 222, 227) 0.6rem, rgb(218, 222, 227) 0.9rem) 0px 0px repeat fixed',
});
